import React, { useState, createContext, useContext } from 'react';
type Language = 'es' | 'en';
interface LanguageContextType {
  lang: Language;
  toggleLang: () => void;
  t: (key: string) => string;
}
const translations = {
  es: {
    // Header
    'nav.services': 'Servicios',
    'nav.technology': 'Tecnología',
    'nav.benefits': 'Beneficios',
    'nav.about': 'Nosotros',
    'nav.locations': 'Ubicaciones',
    'nav.contact': 'Contacto',
    'cta.schedule': 'Agendar Diagnóstico NANO',
    // Services Megamenu
    'services.sports': 'Medicina del Deporte y Traumatología',
    'services.ortho': 'Ortopedia y Reumatología',
    'services.rehab': 'Rehabilitación',
    'services.geriatrics': 'Geriatría',
    'services.aesthetic': 'Medicina Estética (sin bisturí)',
    // Tech Megamenu
    'tech.advanced': 'Neuroingeniería Avanzada',
    // Locations Megamenu
    'loc.polanco': 'Polanco',
    'loc.santafe': 'Santa Fe',
    'loc.lomas': 'Lomas de Chapultepec',
    // Hero
    'hero.badge': 'Nanoneuroingeniería Avanzada',
    'hero.title1': 'Especialistas en Columna',
    'hero.title2': 'y Rehabilitación de',
    'hero.title3': 'Vanguardia',
    'hero.subtitle1': 'Resultados quirúrgicos mediante protocolos',
    'hero.subtitle2': 'no invasivos de alta especialidad.',
    'hero.desc1_start': 'Transformamos tu movilidad y estética a través de la ',
    'hero.desc1_bold': 'Nanoneuroingeniería',
    'hero.desc1_end': '.',
    'hero.desc2': 'Recupera tu calidad de vida con un tratamiento sin dolor, sin',
    'hero.desc3': 'hematomas y con retorno inmediato a tus actividades.',
    'hero.cta1': 'Evaluación Postural y de Movilidad',
    'hero.cta2': 'Consulta de Estética Regenerativa',
    // Hero Slide 2
    'hero.s2.badge': '🏃 Medicina Deportiva',
    'hero.s2.title1': 'Recupera tu',
    'hero.s2.title2': 'rendimiento máximo.',
    'hero.s2.subtitle': 'Rehabilitación deportiva de élite.',
    'hero.s2.desc': 'Tratamientos especializados para atletas y deportistas. Recuperación acelerada con tecnología de estimulación celular avanzada.',
    // Hero Slide 3
    'hero.s3.badge': '✨ Estética Regenerativa',
    'hero.s3.title1': 'Rejuvenece sin',
    'hero.s3.title2': 'cirugía ni bisturí.',
    'hero.s3.subtitle': 'Belleza natural desde el interior.',
    'hero.s3.desc': 'Medicina estética no invasiva que regenera tu piel a nivel celular. Resultados visibles desde la primera sesión.',
    // Services Section
    'services.title': 'SERVICIOS',
    'services.heading': 'Un camino integral hacia tu bienestar',
    'services.subtitle': 'Atención especializada con guía experta, soluciones innovadoras y acompañamiento personalizado en cada paso.',
    'services.listLabel': 'Lista de Servicios',
    'services.desc.sports': 'Recuperación acelerada y optimización del rendimiento deportivo mediante estimulación celular.',
    'services.desc.ortho': 'Tratamiento no invasivo para articulaciones y dolor crónico sin necesidad de cirugía.',
    'services.desc.rehab': 'Restauración de la movilidad y función neuromuscular con tecnología de precisión.',
    'services.desc.geriatrics': 'Mejora de la calidad de vida y autonomía en adultos mayores con terapias regenerativas.',
    'services.desc.aesthetic': 'Rejuvenecimiento facial y corporal a nivel celular, resultados naturales sin tiempo de inactividad.',
    // Why Choose Us
    'why.badge': 'POR QUÉ ELEGIRNOS',
    'why.heading': 'Tu bienestar respaldado por ciencia y tecnología',
    'why.subtitle': 'Combinamos experiencia médica con innovación tecnológica para ofrecerte resultados que transforman vidas.',
    'why.listLabel': 'Nuestros Valores',
    'why.v1.title': 'Tecnología de punta',
    'why.v1.desc': 'Contamos con equipos de Nano Neuroingeniería de última generación, únicos en México, que permiten tratamientos precisos a nivel celular.',
    'why.v2.title': 'Sin dolor ni hematomas',
    'why.v2.desc': 'Nuestros procedimientos son completamente no invasivos. Sin bisturí, sin dolor, sin marcas. Vuelve a tu rutina el mismo día.',
    'why.v3.title': 'Especialistas certificados',
    'why.v3.desc': 'Un equipo multidisciplinario de médicos certificados con amplia experiencia en medicina regenerativa y estética avanzada.',
    'why.v4.title': 'Resultados comprobados',
    'why.v4.desc': 'Miles de pacientes satisfechos avalan la efectividad de nuestros tratamientos con mejoras visibles desde la primera sesión.',
    'why.v5.title': 'Atención personalizada',
    'why.v5.desc': 'Cada protocolo se diseña a la medida de tus necesidades. Tu bienestar es único y así lo tratamos.',
    // Technology
    'tech.title': 'TECNOLOGÍA',
    'tech.heading': 'El Futuro de la Regeneración Celular',
    'tech.desc': 'Nuestra tecnología de Nano Neuroingeniería opera a nivel celular, estimulando los procesos naturales de curación del cuerpo. Utilizamos frecuencias específicas para reparar tejidos, reducir la inflamación y restaurar la función nerviosa sin intervenciones invasivas.',
    'tech.stat1.value': '15,000+',
    'tech.stat1.label': 'Pacientes Tratados',
    'tech.stat2.value': '98%',
    'tech.stat2.label': 'Tasa de Satisfacción',
    'tech.stat3.value': '0',
    'tech.stat3.label': 'Cirugías Necesarias',
    // Locations
    'locations.title': 'UBICACIONES',
    'locations.address.polanco': 'Av. Pdte. Masaryk, Polanco, CDMX',
    'locations.address.santafe': 'Av. Santa Fe, Zedec Sta Fé, CDMX',
    'locations.address.lomas': 'Paseo de las Palmas, Lomas de Chapultepec, CDMX',
    'locations.viewMap': 'Ver Mapa',
    // Contact
    'contact.title': 'CONTACTO',
    'contact.heading': 'Inicia tu transformación hoy',
    'contact.name': 'Nombre completo',
    'contact.phone': 'Teléfono',
    'contact.email': 'Correo electrónico',
    'contact.message': 'Mensaje',
    'contact.send': 'Enviar mensaje',
    'contact.line1': 'Inicia',
    'contact.line2': 'Tu',
    'contact.line3': 'Transformación',
    'contact.callUs': 'Llámanos',
    'contact.writeUs': 'Escríbenos',
    // Testimonials
    'testimonials.badge': '✦ TESTIMONIOS',
    'testimonials.title': 'Historias Reales, Sanación Real — De Nuestra Comunidad',
    'testimonials.subtitle': 'Brindando atención centrada en el paciente a través de orientación experta, soluciones innovadoras y apoyo personalizado en cada paso del camino.',
    'testimonials.t1.title': 'Recuperación increíble',
    'testimonials.t1.quote': 'Después de años con dolor crónico en la espalda, en solo 3 sesiones sentí una mejora que no logré con ningún otro tratamiento. El equipo es excepcional.',
    'testimonials.t1.name': 'María González',
    'testimonials.t1.role': 'Paciente de Rehabilitación',
    'testimonials.t2.title': 'Sin dolor, sin bisturí',
    'testimonials.t2.quote': 'Me dijeron que necesitaba cirugía de rodilla. En Body•On encontré una alternativa que me devolvió la movilidad sin pasar por el quirófano. Estoy agradecido.',
    'testimonials.t2.name': 'Carlos Mendoza',
    'testimonials.t2.role': 'Paciente de Ortopedia',
    'testimonials.t3.title': 'Resultados visibles',
    'testimonials.t3.quote': 'La medicina estética sin bisturí superó mis expectativas. Resultados naturales, sin dolor y sin tiempo de recuperación. Lo recomiendo totalmente.',
    'testimonials.t3.name': 'Ana Rodríguez',
    'testimonials.t3.role': 'Paciente de Estética',
    // Footer
    'footer.rights': 'Todos los derechos reservados.'
  },
  en: {
    // Header
    'nav.services': 'Services',
    'nav.technology': 'Technology',
    'nav.benefits': 'Benefits',
    'nav.about': 'About Us',
    'nav.locations': 'Locations',
    'nav.contact': 'Contact',
    'cta.schedule': 'Schedule NANO Diagnosis',
    // Services Megamenu
    'services.sports': 'Sports Medicine & Traumatology',
    'services.ortho': 'Orthopedics & Rheumatology',
    'services.rehab': 'Rehabilitation',
    'services.geriatrics': 'Geriatrics',
    'services.aesthetic': 'Aesthetic Medicine (no scalpel)',
    // Tech Megamenu
    'tech.advanced': 'Advanced Neuroengineering',
    // Locations Megamenu
    'loc.polanco': 'Polanco',
    'loc.santafe': 'Santa Fe',
    'loc.lomas': 'Lomas de Chapultepec',
    // Hero
    'hero.badge': '⚡ Advanced Nanoneuroengineering',
    'hero.title1': 'Science that rehabilitates',
    'hero.title2': 'and regenerates',
    'hero.title3': 'from within.',
    'hero.subtitle1': 'Surgery results',
    'hero.subtitle2': 'without a single scalpel.',
    'hero.desc': 'We transform your health and aesthetics through Nanoneuroengineering. No pain, no bruising, with minimal recovery time.',
    'hero.cta1': 'Postural and Mobility Evaluation',
    'hero.cta2': 'Regenerative Aesthetics Consultation',
    // Hero Slide 2
    'hero.s2.badge': '🏃 Sports Medicine',
    'hero.s2.title1': 'Recover your',
    'hero.s2.title2': 'peak performance.',
    'hero.s2.subtitle': 'Elite sports rehabilitation.',
    'hero.s2.desc': 'Specialized treatments for athletes and sports professionals. Accelerated recovery with advanced cellular stimulation technology.',
    // Hero Slide 3
    'hero.s3.badge': '✨ Regenerative Aesthetics',
    'hero.s3.title1': 'Rejuvenate without',
    'hero.s3.title2': 'surgery or scalpel.',
    'hero.s3.subtitle': 'Natural beauty from within.',
    'hero.s3.desc': 'Non-invasive aesthetic medicine that regenerates your skin at the cellular level. Visible results from the very first session.',
    // Services Section
    'services.title': 'SERVICES',
    'services.heading': 'A Simplified Path to Comprehensive Care',
    'services.subtitle': 'Providing patient-centered care through expert guidance, innovative solutions, and personalized support every step of the way.',
    'services.listLabel': 'Services List',
    'services.desc.sports': 'Accelerated recovery and sports performance optimization through cellular stimulation.',
    'services.desc.ortho': 'Non-invasive treatment for joints and chronic pain without the need for surgery.',
    'services.desc.rehab': 'Restoration of mobility and neuromuscular function with precision technology.',
    'services.desc.geriatrics': 'Improvement of quality of life and autonomy in older adults with regenerative therapies.',
    'services.desc.aesthetic': 'Facial and body rejuvenation at the cellular level, natural results with no downtime.',
    // Why Choose Us
    'why.badge': 'WHY CHOOSE US',
    'why.heading': 'Your well-being backed by science and technology',
    'why.subtitle': 'We combine medical expertise with technological innovation to deliver life-transforming results.',
    'why.listLabel': 'Our Values',
    'why.v1.title': 'Cutting-edge Technology',
    'why.v1.desc': 'We have state-of-the-art Nano Neuroengineering equipment, unique in Mexico, enabling precise treatments at the cellular level.',
    'why.v2.title': 'No Pain, No Bruising',
    'why.v2.desc': 'Our procedures are completely non-invasive. No scalpel, no pain, no marks. Return to your routine the same day.',
    'why.v3.title': 'Certified Specialists',
    'why.v3.desc': 'A multidisciplinary team of certified physicians with extensive experience in regenerative medicine and advanced aesthetics.',
    'why.v4.title': 'Proven Results',
    'why.v4.desc': 'Thousands of satisfied patients endorse the effectiveness of our treatments with visible improvements from the first session.',
    'why.v5.title': 'Personalized Care',
    'why.v5.desc': 'Every protocol is tailored to your needs. Your well-being is unique and we treat it that way.',
    // Technology
    'tech.title': 'TECHNOLOGY',
    'tech.heading': 'The Future of Cellular Regeneration',
    'tech.desc': "Our Nano Neuroengineering technology operates at the cellular level, stimulating the body's natural healing processes. We use specific frequencies to repair tissues, reduce inflammation, and restore nerve function without invasive interventions.",
    'tech.stat1.value': '15,000+',
    'tech.stat1.label': 'Patients Treated',
    'tech.stat2.value': '98%',
    'tech.stat2.label': 'Satisfaction Rate',
    'tech.stat3.value': '0',
    'tech.stat3.label': 'Surgeries Needed',
    // Locations
    'locations.title': 'LOCATIONS',
    'locations.address.polanco': 'Av. Pdte. Masaryk, Polanco, CDMX',
    'locations.address.santafe': 'Av. Santa Fe, Zedec Sta Fé, CDMX',
    'locations.address.lomas': 'Paseo de las Palmas, Lomas de Chapultepec, CDMX',
    'locations.viewMap': 'View Map',
    // Contact
    'contact.title': 'CONTACT',
    'contact.heading': 'Start your transformation today',
    'contact.name': 'Full Name',
    'contact.phone': 'Phone',
    'contact.email': 'Email',
    'contact.message': 'Message',
    'contact.send': 'Send Message',
    'contact.line1': 'Start',
    'contact.line2': 'Your',
    'contact.line3': 'Transformation',
    'contact.callUs': 'Call Us',
    'contact.writeUs': 'Write Us',
    // Testimonials
    'testimonials.badge': '✦ TESTIMONIALS',
    'testimonials.title': 'Real Stories, Real Healing — From Our Community',
    'testimonials.subtitle': 'Providing patient-centered care through expert guidance, innovative solutions, and personalized support every step of the way.',
    'testimonials.t1.title': 'Incredible recovery',
    'testimonials.t1.quote': 'After years of chronic back pain, in just 3 sessions I felt an improvement I never achieved with any other treatment. The team is exceptional.',
    'testimonials.t1.name': 'María González',
    'testimonials.t1.role': 'Rehabilitation Patient',
    'testimonials.t2.title': 'No pain, no scalpel',
    'testimonials.t2.quote': 'I was told I needed knee surgery. At Body•On I found an alternative that restored my mobility without going through the operating room. I am grateful.',
    'testimonials.t2.name': 'Carlos Mendoza',
    'testimonials.t2.role': 'Orthopedics Patient',
    'testimonials.t3.title': 'Visible results',
    'testimonials.t3.quote': 'Scalpel-free aesthetic medicine exceeded my expectations. Natural results, no pain and no recovery time. I totally recommend it.',
    'testimonials.t3.name': 'Ana Rodríguez',
    'testimonials.t3.role': 'Aesthetics Patient',
    // Footer
    'footer.rights': 'All rights reserved.'
  }
};
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export const LanguageProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [lang, setLang] = useState<Language>('es');
  const toggleLang = () => {
    setLang(prev => prev === 'es' ? 'en' : 'es');
  };
  const t = (key: string): string => {
    return (translations[lang] as any)[key] || key;
  };
  return <LanguageContext.Provider value={{
    lang,
    toggleLang,
    t
  }} data-id="element-222">
      {children}
    </LanguageContext.Provider>;
};
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};